import DataMapper from './DataMapper'
import Instruction from '../../models/Instructions'
import InstructionRM from '../responsemodel/InstructionRM'
import UserDataMapper from './UserDataMapper'

class InstructionDataMapper extends DataMapper<InstructionRM, Instruction> {
  private userDataMapper = new UserDataMapper()
  map = (rm: InstructionRM) => {
    const by:any = this.userDataMapper.map(rm.by)
    const to: any = this.userDataMapper.map(rm.to)
    return new Instruction(rm.id, rm.instructionType, rm.state, rm.postedOn, rm.instruction, by, to, rm.instructionStatus, rm.instructionStatusEvidence)
  }
}

export default InstructionDataMapper
